type CamelCase<T> = {
  [K in keyof T as K extends string ? CamelCaseKey<K> : K]: T[K];
};

type CamelCaseKey<T extends string> = T extends `${infer First}_${infer Rest}`
  ? `${First}${Capitalize<CamelCaseKey<Rest>>}`
  : T;

function toCamelCase(str: string): string {
  return str.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
}

export function convertKeysToCamelCase<T extends Record<string, unknown>>(
  obj: T
): CamelCase<T> {
  return Object.keys(obj).reduce((acc, key) => {
    const newKey = toCamelCase(key) as keyof CamelCase<T>;
    acc[newKey] = obj[key as keyof T] as CamelCase<T>[typeof newKey];
    return acc;
  }, {} as CamelCase<T>);
}
